import { BlueprintStepTemplate } from "../../../models/Blueprints";
import useBlueprintContext from "../context/useBlueprintContext";
import {
  isPaginationTimestampAvailable,
  checkPaginationTimestampUsed,
} from "../utils/BlueprintEditorUtils";
import BlueprintEditorRightPanelAPIRequestForm from "./BlueprintEditorRightPanelAPIRequestForm";
import { Toggle } from "@merge-api/merge-javascript-shared";

interface Props {
  stepID: string;
  stepTemplate: BlueprintStepTemplate;
}

const BlueprintEditorRightPanelAPIRequestLoopForm = (props: Props) => {
  const { blueprint, selectedStep, setStepUsesPaginationTimestamp } = useBlueprintContext();

  const canTogglePaginationTimestamps = isPaginationTimestampAvailable(
    blueprint.operation_type,
    blueprint.trigger_type
  );
  const paginationTimestampUsed = checkPaginationTimestampUsed(selectedStep);

  const updateUsePaginationTimeStamps = () => {
    setStepUsesPaginationTimestamp(props.stepID, !paginationTimestampUsed);
  };

  return (
    <>
      {canTogglePaginationTimestamps && (
        <Toggle
          className="mb-9"
          checked={paginationTimestampUsed}
          disableDefaultOnChange
          labelPlacement="right"
          onChange={updateUsePaginationTimeStamps}
          label="Enable Pagination Timestamps"
        />
      )}
      <BlueprintEditorRightPanelAPIRequestForm {...props} />
    </>
  );
};

export default BlueprintEditorRightPanelAPIRequestLoopForm;
